module.exports = __webpack_public_path__ + "f3dbc9c18838322b5e7ecabc4f62f8e1.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/event-res_pop.png
 ** module id = 1063
 ** module chunks = 0
 **/